import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import productService from './productService';

const initialState = {
    products: [],
    product: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: '',
};

// Thunks
export const fetchProducts = createAsyncThunk('products/fetchAll', async (_, thunkAPI) => {
    try {
        return await productService.getAllProducts();
    } catch (error) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            'Failed to fetch products';
        return thunkAPI.rejectWithValue(message);
    }
});

export const fetchProductById = createAsyncThunk('products/fetchById', async (id, thunkAPI) => {
    try {
        return await productService.getProductById(id);
    } catch (error) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            'Failed to fetch product';
        return thunkAPI.rejectWithValue(message);
    }
});

export const fetchProductBySlug = createAsyncThunk(
    'products/fetchProductBySlug',
    async (slug, thunkAPI) => {
        try {
            const response = await productService.getProductBySlug(slug);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || 'Error fetching product');
        }
    }
);

// Slice
const productSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
            state.message = '';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProducts.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.products = action.payload.data;
            })
            .addCase(fetchProducts.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(fetchProductById.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchProductById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.product = action.payload.data;
            })
            .addCase(fetchProductById.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(fetchProductBySlug.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchProductBySlug.fulfilled, (state, action) => {
                state.isLoading = false;
                state.product = action.payload;
            })
            .addCase(fetchProductBySlug.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload as string;
            });

    },
});

export const { reset } = productSlice.actions;
export default productSlice.reducer;